import { supabaseClient } from 'supabase'
import { requireStamp } from './deskDecisionError'

/** The two outcomes of an Updates-tab candidate (D-15). */
export type DeskUpdateDecision = 'update_applied' | 'update_dismissed'

export type DecideUpdateParams = {
  id: number
  decision: DeskUpdateDecision
  /**
   * The fields copied onto the existing event, sent as given. The RPC records
   * them only for 'update_applied'; pass null (or omit) for a dismissal.
   */
  editedFields?: string[] | null
}

/**
 * Decide an update candidate: apply it to the matched event or dismiss it
 * (`desk_decide_update`, D-15). The RPC does not check the route and stamps
 * who decided and when itself.
 *
 * Resolves with the `desk_decided_at` it stamped, exactly as sent (the Undo
 * guard of a dismissal, review AD-WR-11).
 *
 * Errors are thrown raw; a null result throws DeskAlreadyDecidedError (D-11).
 */
export const decideUpdate = async ({
  id,
  decision,
  editedFields = null
}: DecideUpdateParams): Promise<string> => {
  const { data, error } = await supabaseClient.rpc('desk_decide_update', {
    p_id: id,
    p_decision: decision,
    p_edited_fields: editedFields
  })

  if (error) {
    throw error
  }
  return requireStamp('desk_decide_update', data)
}
